/**
 * Enum for preorder external status values
 */
var PreorderExternalStatus;
(function (PreorderExternalStatus) {
    PreorderExternalStatus["PENDING_INVITATION"] = "PENDING_INVITATION";
    PreorderExternalStatus["AWAITING_CHECKOUT"] = "AWAITING_CHECKOUT";
    PreorderExternalStatus["IDLE"] = "IDLE";
    PreorderExternalStatus["CONVERTED"] = "CONVERTED";
    PreorderExternalStatus["CANCELED"] = "CANCELED";
})(PreorderExternalStatus || (PreorderExternalStatus = {}));
/** Maps PreorderExternalStatus enum values to human-readable display labels */
const PREORDER_STATUS_DISPLAY_LABEL = {
    [PreorderExternalStatus.PENDING_INVITATION]: 'Pending invitation',
    [PreorderExternalStatus.AWAITING_CHECKOUT]: 'Awaiting checkout',
    [PreorderExternalStatus.IDLE]: 'Idle',
    [PreorderExternalStatus.CONVERTED]: 'Converted',
    [PreorderExternalStatus.CANCELED]: 'Canceled',
};

export { PREORDER_STATUS_DISPLAY_LABEL, PreorderExternalStatus };
//# sourceMappingURL=Preorder.js.map
